import { render, staticRenderFns } from "./BuildBadge.vue?vue&type=template&id=adbade90&scoped=true"
import script from "./BuildBadge.vue?vue&type=script&lang=js"
export * from "./BuildBadge.vue?vue&type=script&lang=js"
import style0 from "./BuildBadge.vue?vue&type=style&index=0&id=adbade90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adbade90",
  null
  
)

export default component.exports